<template>
  <b-modal
      :id="customId"
      ref="modal"
      :title="title"
      :ok-title="submitTitle"
      :cancel-title="cancelTitle"
      :ok-only="isUnder"
      :no-close-on-backdrop="isUnder"
      :centered="true"
      :hide-header-close="true"
      :ok-variant="`modal-component-${modalType}`"
      footer-class="modal-component-footer"
      cancel-variant="modal-component-normal"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
  >
    <div class="d-flex justify-content-center flex-column align-items-center" :class="`color-${modalType}`">

      <div v-if="!iconType.includes('circle')" class="no-circle">
        <i class="fas fs-80 fa-fw" :class="`fa-${iconType}`"></i>
      </div>
      <template v-else>
        <i class="fas fs-150 fa-fw" :class="`fa-${iconType}`"></i>
      </template>
      <br>
      <h5 class="modal-message-type">{{ messageType }}</h5>
      <span v-if="subMessage" class="modal-sub-message">{{ subMessage }}</span>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "confirmationModal",
  data() {
    return {
      submitValue: false,
    }
  },
  computed: {
    isUnder() {
      return this.confirmationType === 'under'
    },
    modalType() {
      if (this.confirmationType === "approve") {
        return "success"
      } else if (this.confirmationType === "reject") {
        return "danger"
      } else if (this.confirmationType === "delete") {
        return "danger"
      } else if (this.confirmationType === "apply") {
        return "apply"
      } else if (this.confirmationType === "jobApprove") {
        return "success"
      } else if (this.confirmationType === "jobReject") {
        return "danger"
      } else if (this.confirmationType === "jobSummited") {
        return "apply"
      } else if (this.confirmationType === "under") {
        return "danger"
      } else {
        return ""
      }
    },
    iconType() {
      if (this.confirmationType === "approve") {
        return "check-circle"
      } else if (this.confirmationType === "reject") {
        return "times-circle"
      } else if (this.confirmationType === "delete") {
        return "trash"
      } else if (this.confirmationType === "apply") {
        return "file-alt"
      } else if (this.confirmationType === "jobApprove") {
        return "check-circle"
      } else if (this.confirmationType === "jobReject") {
        return "times-circle"
      } else if (this.confirmationType === "jobSummited") {
        return "file-alt"
      } else if (this.confirmationType === "under") {
        return "wrench"
      } else {
        return ""
      }
    },
    messageType() {
      if (this.confirmationType === "approve") {
        return "ท่านต้องการที่จะอนุมัติคำขอนี้"
      } else if (this.confirmationType === "reject") {
        return "ท่านต้องการที่จะไม่อนุมัติคำขอนี้"
      } else if (this.confirmationType === "delete") {
        return "ท่านต้องการที่จะลบประกาศงานนี้"
      } else if (this.confirmationType === "apply") {
        return "ท่านต้องการที่จะส่งใบสมัครงานนี้"
      } else if (this.confirmationType === "jobApprove") {
        return "ยืนยันนักศึกษาผ่านการสัมภาษณ์"
      } else if (this.confirmationType === "jobReject") {
        return "ยืนยันนักศึกษาไม่ผ่านการสัมภาษณ์"
      } else if (this.confirmationType === "jobSummited") {
        return "ส่งใบสมัครเรียบร้อย"
      } else if (this.confirmationType === "under") {
        return "กำลังปรับปรุงระบบ"
      } else {
        return ""
      }
    },
    subMessage() {
      if (this.confirmationType === "jobSummited") {
        return "สามารถดูประวัติการสมัครได้ที่หน้า 'งานที่ฉันสมัคร'"
      } else {
        return null
      }

    }
  },
  props: {
    eventName: {
      type: String
    },
    title: {
      type: String
    },
    confirmationType: {
      type: String
    },
    submitTitle: {
      type: String
    },
    cancelTitle: {
      type: String
    },
    customId: {
      type: String,
      required: true
    }
  },
  methods: {
    resetModal() {
      this.submitValue = ''
    },
    handleOk(bvModalEvt) {
      this.submitValue = {
        type: this.confirmationType,
        value: true
      };
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Push the name to submitted names
      this.$emit(this.eventName, this.submitValue)
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide(this.customId)
      })
    }
  }
}
</script>

<style>
.modal-backdrop {
  opacity: .5;
}

.modal-component-footer {
  display: flex;
  justify-content: center !important;
}

.color-danger {
  color: #E94244;
}

.color-success {
  color: #0f6848;
}

.color-apply {
  color: #2F80ED;
}

</style>
<style scoped>
.fs-150 {
  font-size: 150px;
}

.fs-80 {
  font-size: 80px;
}

.no-circle {
  height: 150px;
  min-width: 150px;
  background: #E94244 !important;
  justify-content: center;
  display: flex;
  color: #FFF;
  border-radius: 50%;
  font-size: 84px !important;
  align-items: center;
}

.modal-message-type {
  font-weight: bold;
}

.modal-sub-message {
  color: #8f8f8f;
}
</style>